import { onMounted, ref } from "vue";

export default {
  name: "LandingBackgroundVideo",
  setup() {
    const landing_page_video = ref(null);

    onMounted(() => {
      const video_el = landing_page_video.value;

      if (!(video_el instanceof HTMLVideoElement)) {
        return;
      }

      const video_src = getComputedStyle(document.documentElement)
        .getPropertyValue("--landing-page-video")
        .replace(/url\(|\)|"|'/g, "")
        .trim();

      if (!video_src) {
        return;
      }

      video_el.src = video_src;
      video_el.load();
    });

    return ({
      landing_page_video,
    });
  },
};
